<app-generic-container>
    <!-- Usamos el panel genérico -->

    <app-generic-panel [title]="panelTitle " [description]="panelDescription" [awesomeIcon]="panelIcon">


        <div class="col-12 mt-4 row">
            <div class="col-6">
                <app-dropdown-formularios dataSize="7" placeHolder="Empresa" [selectedValue]=""
                    (selectedValueChange)="companySelectedChanged($event)" [required]="true" [disabled]="false"
                    [dropdownType]="'Companies'" detailedData="true">
                </app-dropdown-formularios>
            </div>
            <div class="col-6">
                <app-dropdown-formularios dataSize="7" placeHolder="Categoría"
                    (selectedValueChange)="setCategories($event)" [required]="true" [dropdownType]="'DocCategories'"
                    smallA3Doc="true" *ngIf="company">
                </app-dropdown-formularios>
            </div>
        </div>

        <div class="col-12 mt-4">
            <legend class="pl-0">Documentos</legend>
            <dx-data-grid #documentGrid id="gridContainer" [dataSource]="dataSourceDocs"
                (onEditorPreparing)="onEditorPreparing($event)"
                [selection]="{ mode: 'multiple', selectAllMode: 'allPages' }">

                <!-- Definición de las columnas -->
                <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>
                <dxi-column dataField="title" caption="Nombre del documento"></dxi-column>
                <dxi-column dataField="customerName" caption="Empresa"></dxi-column>
                <dxi-column dataField="containersNames" caption="Categoría" alignment="center"></dxi-column>
                <dxi-column dataField="date" caption="Creación" alignment="center" dataType="date" format="dd/MM/yyyy"
                    [sortOrder]="'desc'">
                </dxi-column>
                <dxi-column caption="" [fixed]="true" [fixedPosition]="'right'" [visible]="false">
                    <dxi-column dataField="doc1" caption="Acciones" [allowFiltering]="false" [allowSorting]="false"
                        alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
                </dxi-column>
            </dx-data-grid>

        </div>
        <div class="col-12 mt-2">
            <legend class="pl-0">Empleados</legend>
            <dx-data-grid #userGrid id="gridContainer" [dataSource]="dataSourceUsuario"
                (onEditorPreparing)="onEditorPreparing($event)"
                [selection]="{ mode: 'multiple', selectAllMode: 'allPages' }">

                <!-- Definición de las columnas -->
                <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>
                <dxi-column caption="Empresa" alignment="center">
                    <dxi-column dataField="company.companyCode" caption="Código" alignment="center"></dxi-column>
                    <dxi-column dataField="company.name" caption="Empresa" alignment="center"> </dxi-column>
                </dxi-column>
                <dxi-column caption="Centro" alignment="center">
                    <dxi-column dataField="workplaceCode" caption="Código" alignment="center"> </dxi-column>
                    <dxi-column dataField="workplaceName" caption="Centro" alignment="center"> </dxi-column>
                </dxi-column>
                <dxi-column caption="Imputación" alignment="center">
                    <dxi-column dataField="imputationCode" caption="Código" alignment="center"> </dxi-column>
                    <dxi-column dataField="imputationName" caption="Imputacion" alignment="center"> </dxi-column>
                </dxi-column>
                <dxi-column caption="Trabajador" alignment="center">
                    <dxi-column dataField="employeeCode" caption="Código" alignment="center"> </dxi-column>
                    <dxi-column dataField="fullName" caption="Trabajador" alignment="center"> </dxi-column>
                    <dxi-column dataField="hiringDate" caption="Alta" alignment="center" dataType="date"
                        format="dd/MM/yyyy" [sortOrder]="'desc'"> </dxi-column>

                </dxi-column>
                <dxi-column caption="" [fixed]="true" [fixedPosition]="'right'" [visible]="false">
                    <dxi-column dataField="IdUsuario" caption=" " [allowFiltering]="false" [allowSorting]="false"
                        alignment="center" [allowExporting]="false" cellTemplate="buttonCRUDTemplate"></dxi-column>
                </dxi-column>

            </dx-data-grid>

        </div>

        <!-- Botonera -->
        <div class="row col-12 float-right " *ngIf="company && categories">
            <label class="col-12"></label>
            <div class="col-12">
                <div class="form-group form-button">
                    <button class="btn btn-fill btn-primary float-right" [disabled]="true" (click)="onSaveClick()"
                        [disabled]="loading">Guardar</button>
                    <a class="btn btn-fill btn-outline-white float-right" routerLink="../"
                        [disabled]="loading">Volver</a>
                </div>
            </div>
        </div>

    </app-generic-panel>
</app-generic-container>